import React, { useEffect, useState, useRef } from 'react'
import {
    Button,
    Checkbox,
    Col,
    Icon,
    Input,
    message,
    Modal,
    Row,
    Select,
    Table,
    Tag,
    Tooltip,
    Typography
} from 'antd';
import AstRecord from '../ast/AstRecord';
import PhotoGalleryModal from '../ast/PhotoGalleryModal';
import PhotoThumb from '../ast/PhotoThumb';
import './style.css'
import PvRecord from './PvRecordReconciliation';

function PvReconciliation({ assets, data: pvData, voucher, locations, clients, exportedData, setExportedData, ...props }) {
    const [columns, setColumns] = useState([])

    const [searchText, setsearchText] = useState('');
    const [searchedColumn, setsearchedColumn] = useState();
    const searchInput = useRef(null);

    const [data, setData] = useState([])
    const [pvSummary, setPvSummary] = useState(null)
    const [selectableAssets, setSelectableAssets] = useState([])

    const [actions, setActions] = useState([])
    const [recordAction, setRecordActions] = useState(null)


    useEffect(() => {
        const options = props.filters && props.filters['actionTaken.name'] && props.filters['actionTaken.name']['options'] && props.filters['actionTaken.name']['options']['enum']
        setActions(options || []);
    }, [props.filters])

    useEffect(() => {
        // console.log(astData);
        setData(pvData)
    }, [pvData]);

    useEffect(() => {
        const dataWithUsedAssets = data.filter(d => d.actionTaken && d.actionTaken.name === 'LINK_ASSET' && d.actionTaken.refRecordId).map(a => a.actionTaken.refRecordId.toString())
        setSelectableAssets((assets || []).filter(sa => !(dataWithUsedAssets || []).includes(sa._id.toString())))
    }, [assets, data])


    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput.current = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current.select(), 100);
            }
        },
        render: text => (dataIndex !== 'location' && dataIndex !== 'client') ?
            (
                text
            ) :
            dataIndex === 'location' ? (text && props.authUser && props.authUser.locations && props.authUser.locations.length)
                && props.authUser.locations.findIndex(loc => loc._id === text) >= 0 && props.authUser.locations[props.authUser.locations.findIndex(loc => loc._id === text)]['name']
                :
                dataIndex === 'client' ? (text && props.authUser && props.authUser.clients && props.authUser.clients.length)
                    && props.authUser.clients.findIndex(loc => loc._id === text) >= 0 && props.authUser.clients[props.authUser.clients.findIndex(loc => loc._id === text)]['name'] : ''
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setsearchText(selectedKeys[0]);
        setsearchedColumn(dataIndex);
    };

    const handleReset = clearFilters => {
        clearFilters();
        setsearchText('');
    };

    useEffect(() => {
        // const options = props.filters && props.filters['actionTaken.name'] && props.filters['actionTaken.name']['options'] && props.filters['actionTaken.name']['options']['enum']
        // console.log(options)
        setColumns(
            [
                // {
                //     title: '_id',
                //     dataIndex: '_id',
                //     key: '_id'
                // },
                {
                    title: 'TempCode',
                    dataIndex: 'tempAssetCode',
                    key: 'assetCode',
                    ...getColumnSearchProps('tempAssetCode'),
                },
                {
                    title: 'PV',
                    dataIndex: 'pvNo',
                    key: 'pvNo',
                    // render: (pvNo, record) => {
                    //     return <Button type='link' onClick={() => handleShowModel(record._id)}>{pvNo}</Button>
                    // },
                    ...getColumnSearchProps('pvNo'),
                },
                {
                    title: 'Photos',
                    key: 'photos',
                    // Thumbnail of the first inline photo + exact count badge. Uses record.photos
                    // directly (no fetch). Click opens the full gallery.
                    render: (_, record) => (
                        <PhotoThumb photos={record && record.photos} onClick={() => handleShowGallery(record)} />
                    )
                },
                {
                    title: 'Location',
                    dataIndex: 'location',
                    key: 'location',
                    render: location => {
                        if (location && locations.length) {
                            const locIndex = locations.findIndex(loc => loc._id === location);
                            return locIndex >= 0 && locations[locIndex]['name']
                        }
                    },
                    // ...getColumnSearchProps('location'),
                    filters: (locations.map(l => ({ text: l.name, value: l._id }))),
                    onFilter: (value, record) => record.location.indexOf(value) === 0,
                },
                {
                    title: 'SubLocation',
                    dataIndex: 'client',
                    key: 'client',
                    render: client => {
                        if (client && clients.length) {
                            const clIndex = clients.findIndex(cl => cl._id === client);
                            return clIndex >= 0 && clients[clIndex]['name']
                        }
                    },
                    // ...getColumnSearchProps('client'),
                    filters: clients.map(c => ({ text: c.name, value: c._id })),
                    onFilter: (value, record) => record.client.indexOf(value) === 0,
                },
                {
                    title: 'Model',
                    dataIndex: 'assetModel',
                    key: 'assetModel',
                    render: assetModel => assetModel && assetModel.name
                },
                {
                    title: 'Sub Type',
                    dataIndex: 'equipmentSubType',
                    key: 'equipmentSubType',
                    render: equipmentSubType => equipmentSubType && equipmentSubType.name
                },
                {
                    title: 'Asset Type',
                    dataIndex: 'assetType',
                    key: 'assetType',
                    render: assetType => assetType && assetType.name
                },
                {
                    title: 'Action',
                    key: 'action',
                    render: (_, record) => {
                        // console.log(record && record.actionTaken && record.actionTaken.name);
                        let value = record && record.actionTaken && record.actionTaken.name;
                        // if (!value) {
                        //     value = 'NEW_ASSET'
                        // }
                        // console.log(value);

                        // ||(record.reconcileStatus && record.reconcileStatus === 'FULLY_MATCHED') ? 'RECONCILED' : record.reconcileStatus === 'SOLD' ? 'SOLD' : ''
                        return (
                            <Select
                                allowClear
                                // Locked only once the record is processed. A saved-but-not-processed
                                // record can still have its action changed (it will be re-saved on Save).
                                disabled={record && record.isProcessed}
                                value={value}
                                style={{ width: 120 }}
                                onChange={value => handleActionSelectChange(value, record)}
                            >
                                {['LINK_ASSET', 'NEW_ASSET', 'IGNORE'].map(op => <Select.Option key={op} value={op}><Tooltip title={op}>{op}</Tooltip></Select.Option>)}
                            </Select>
                        )
                    }
                },
                {
                    title: 'Linked Asset',
                    dataIndex: 'actionTaken',
                    key: 'actionTaken',
                    render: (actionTaken) => actionTaken && actionTaken.name === 'LINK_ASSET' && actionTaken.refRecordSubId
                },
                {
                    title: 'New Owner',
                    dataIndex: 'actionTaken',
                    key: 'actionTaken',
                    render: (actionTaken) => {
                        if (actionTaken && actionTaken.name === 'NEW_ASSET' && actionTaken.newAssetOwner) {
                            const owners = props.filters && props.filters['actionTaken.newAssetOwner'] && props.filters['actionTaken.newAssetOwner']['data']
                                && props.filters['actionTaken.newAssetOwner']['data']['data'] || [];
                            const i = owners.findIndex(o => o._id.toString() === actionTaken.newAssetOwner.toString())
                            return i >= 0 ? owners[i]['name'] : ''
                        }
                    }
                },
                {
                    title: 'Overwrite Asset',
                    dataIndex: 'isPvOverwrite',
                    key: 'isPvOverwrite',
                    render: (_, record) => (record && record.actionTaken && record.actionTaken.isPvOverwrite) ? <Tooltip title="Yes"><Icon type="check-circle" style={{ fontSize: '25px' }} theme="twoTone" twoToneColor="#52c41a" /></Tooltip> :
                        <Tooltip title="No"><Icon type="close-circle" theme="twoTone" style={{ fontSize: '25px' }} twoToneColor="#eb2f96" /></Tooltip>
                },
                {
                    title: 'Is Saved',
                    dataIndex: 'isAlreadySaved',
                    key: 'isAlreadySaved',
                    render: (isAlreadySaved, record) => (isAlreadySaved && record && record.saveId) ? <Tooltip title="Yes"><Icon type="check-circle" style={{ fontSize: '25px' }} theme="twoTone" twoToneColor="#52c41a" /></Tooltip> :
                        <Tooltip title="No"><Icon type="close-circle" theme="twoTone" style={{ fontSize: '25px' }} twoToneColor="#eb2f96" /></Tooltip>
                },
                {
                    title: 'Is Processed',
                    dataIndex: 'isProcessed',
                    key: 'isProcessed',
                    render: (isProcessed) => isProcessed ? <Tooltip title="Yes"><Icon type="check-circle" style={{ fontSize: '25px' }} theme="twoTone" twoToneColor="#52c41a" /></Tooltip> :
                        <Tooltip title="No"><Icon type="close-circle" theme="twoTone" style={{ fontSize: '25px' }} twoToneColor="#eb2f96" /></Tooltip>
                },
                {
                    title: 'Remarks',
                    dataIndex: 'processedRemark',
                    key: 'processedRemark',
                },
            ]
        )
    }, [props.filters, data]);

    const rowClassName = (record) => {
        return record.isProcessed ? 'row-processed' : record.isAlreadySaved ? 'row-saved' : '';
    };

    const [showModel, setshowModel] = useState(false);
    const [showModelData, setshowModelData] = useState(null);

    const handleShowModel = (pvAssetRecordId) => {
        if (pvAssetRecordId) {
            const pv = data.filter(d => d._id === pvAssetRecordId)
            // console.log(astAssetRecordId, ast);
            setshowModelData(pv && pv[0]);
            setshowModel(true);
        }
    }

    const hideModel = () => {
        setshowModel(false)
        setRecordActions(null)
        setshowModelData(null)
    }

    // ----- Photo gallery pop-up (per-row photos captured during PV) -----
    const [showGallery, setShowGallery] = useState(false);
    const [galleryData, setGalleryData] = useState(null);

    const handleShowGallery = (record) => {
        setGalleryData(record);
        setShowGallery(true);
    };

    const hideGallery = () => setShowGallery(false);

    // ----- Bulk action (applies to all currently visible/filtered PV rows) -----
    // Allowed bulk actions: NEW_ASSET (asks for a single owner applied to all) and IGNORE.
    // Mirrors the AST tab's "add this action to all above" behaviour.
    const [bulkActionValue, setBulkActionValue] = useState(null);

    // A row is eligible for bulk action as long as it is not yet processed.
    // This intentionally includes rows that are already saved (but not processed)
    // and rows that already carry a chosen action, so bulk can *change* them.
    // Processed rows are final and are never touched. Scope the change by
    // filtering the table first — bulk applies to the currently visible rows.
    const isBulkEligible = (doc) => !doc.isProcessed;

    const applyBulkAction = (actionName, newAssetOwner) => {
        let applied = 0;
        const updated = data.map(doc => {
            if (isBulkEligible(doc)) {
                doc.actionTaken = newAssetOwner ? { name: actionName, newAssetOwner } : { name: actionName };
                doc.isAlreadySaved = true;
                doc.actionRecord = null;
                applied += 1;
            }
            return doc;
        });
        setData([...updated]);
        message.success(`${actionName} applied to ${applied} record${applied === 1 ? '' : 's'}.`);
    };

    const handleBulkActionChange = () => {
        if (!bulkActionValue) return;

        const eligibleCount = data.filter(isBulkEligible).length;
        if (!eligibleCount) {
            message.info('No eligible visible records to apply the action to.');
            return;
        }

        if (bulkActionValue === 'NEW_ASSET') {
            const owners = props.filters && props.filters['actionTaken.newAssetOwner'] && props.filters['actionTaken.newAssetOwner']['data']
                && props.filters['actionTaken.newAssetOwner']['data']['data'] || [];
            let selectedOwner = null;
            Modal.confirm({
                title: `Choose owner for ${eligibleCount} new asset${eligibleCount === 1 ? '' : 's'}`,
                content: (
                    <div>
                        <p>NEW_ASSET (with the selected owner) will be applied to all {eligibleCount} visible, not-yet-processed record{eligibleCount === 1 ? '' : 's'} — this <b>overwrites</b> any existing action on those rows (including saved-but-not-processed ones). Processed rows are untouched.</p>
                        <Select allowClear style={{ width: '100%' }} placeholder="Select owner"
                            onChange={(v) => { selectedOwner = v; }}>
                            {owners.map(ow => <Select.Option key={ow._id} value={ow._id}><Tooltip title={ow.name}>{ow.name}</Tooltip></Select.Option>)}
                        </Select>
                    </div>
                ),
                okText: 'Apply',
                onOk: () => {
                    if (!selectedOwner) {
                        message.warning('Please select an owner to continue.');
                        return Promise.reject();
                    }
                    applyBulkAction('NEW_ASSET', selectedOwner);
                },
            });
        } else if (bulkActionValue === 'IGNORE') {
            Modal.confirm({
                title: `Apply IGNORE to ${eligibleCount} visible record${eligibleCount === 1 ? '' : 's'}?`,
                content: <div>This <b>overwrites</b> any existing action on those rows (including saved-but-not-processed ones). Processed rows are untouched. Are you sure?</div>,
                onOk: () => applyBulkAction('IGNORE'),
            });
        }
    };

    const handleActionSelectChange = (action, pvRecord) => {
        // console.log(props.filters);

        if (!pvRecord) return;

        // Cleared (allowClear) -> reset this row back to a null / no-action state.
        if (!action) {
            setRecordActions(null);
            setData(data.map(doc => {
                if (doc._id === pvRecord._id) {
                    delete doc.actionTaken;
                    doc.actionRecord = null;
                    // Only a truly persisted row keeps its saved flag (saveId). A row
                    // that was merely marked saved locally reverts to unsaved so it no
                    // longer appears actioned.
                    if (!doc.saveId) doc.isAlreadySaved = false;
                }
                return doc;
            }));
            return;
        }

        if (action && pvRecord) {
            setRecordActions(action)
            if (action === 'LINK_ASSET') {
                setshowModelData(pvRecord);
                setshowModel(true);
            } else if (action === 'NEW_ASSET') {
                const owners = props.filters && props.filters['actionTaken.newAssetOwner'] && props.filters['actionTaken.newAssetOwner']['data']
                    && props.filters['actionTaken.newAssetOwner']['data']['data'] || []
                Modal.confirm({
                    title: `Choose owner for the new asset!`,
                    content: <div>
                        <Select
                            allowClear
                            style={{ width: 120 }}
                            onChange={(v) => {
                                setData(data.map(doc => {
                                    if (doc._id === pvRecord._id) {

                                        doc.actionTaken = { name: action, newAssetOwner: v }
                                        doc.isAlreadySaved = true
                                        doc.actionRecord = null
                                    }
                                    return doc
                                }))
                            }}
                        >
                            {owners.map(ow => <Select.Option key={ow._id} value={ow._id}><Tooltip title={ow.name}>{ow.name}</Tooltip></Select.Option>)}
                        </Select>
                    </div>,
                    onCancel: () => {
                        setData(data.map(doc => {
                            if (doc._id === pvRecord._id) {

                                doc.actionTaken = { name: action }
                                doc.isAlreadySaved = true
                                doc.actionRecord = null
                            }
                            return doc
                        }))
                    }
                });

            } else {
                //save
                setData(data.map(doc => {
                    if (doc._id === pvRecord._id) {

                        doc.actionTaken = { name: action }
                        doc.isAlreadySaved = true
                        doc.actionRecord = null
                    }
                    return doc
                }))
            }
        }

    }

    const changeTable = (pagination, filters, sorter, extra) => {
        // console.log(pagination, filters);
        // console.log(extra);

        const { currentDataSource } = extra;
        setData(currentDataSource)

    }

    //when select an asset in modal
    const handleRecordAction = (actionRecord, willBeOverwritten, action) => {
        if (actionRecord && action) {
            // save

            setData(data.map(doc => {
                if (doc._id === showModelData._id) {

                    doc.actionTaken = { name: action, refRecordId: actionRecord._id, refRecordSubId: actionRecord.assetCode, isPvOverwrite: willBeOverwritten }
                    doc.isAlreadySaved = true
                    doc.actionRecord = actionRecord
                }
                return doc
            }))

            //remove the selected asset from the list
            setSelectableAssets(selectableAssets.map(a => a._id !== actionRecord._id))
        }
    }

    useEffect(() => {
        const { allAssets, pvAssets, astAssets } = exportedData || {};
        setExportedData({ allAssets, pvAssets: data, astAssets })
    }, [data])

    // Summary of the current (filtered/visible) PV rows: how many carry each
    // action and how many of those are actually saved (persisted, have a saveId),
    // plus how many have no action at all. Counts are exact — a row with no
    // action falls into the NO_ACTION bucket, never silently dropped.
    useEffect(() => {
        if (data && data.length) {
            const byAction = data.reduce((acc, curr) => {
                const actionName = (curr.actionTaken && curr.actionTaken.name) || 'NO_ACTION';
                if (!acc[actionName]) acc[actionName] = { total: 0, saved: 0, processed: 0 };
                acc[actionName].total += 1;
                if (curr.saveId) acc[actionName].saved += 1;
                if (curr.isProcessed) acc[actionName].processed += 1;
                return acc;
            }, {});
            setPvSummary({ total: data.length, byAction });
        } else {
            setPvSummary(null);
        }
    }, [data])

    const submitReconcileData = () => {
        // console.log(data)
        const payload = data.filter(doc => doc.actionTaken && doc.actionTaken.name && !doc.isProcessed)
        // console.log(payload);
        Modal.confirm({
            title: `Are you sure to save ${payload.length} records! ?`,
            content: <div>Are you sure ?</div>,
            onOk: () => {
                message.info(`${payload.length} records will be saving!`)
                props.saveReconciliationData(payload, voucher, 'pv');
            },
        });
    }

    const processReconcileData = () => {
        // console.log(data)
        const payload = data.filter(doc => doc.actionTaken && doc.actionTaken.name && doc.isAlreadySaved && doc.saveId && !doc.isProcessed)
        // console.log(payload);
        Modal.confirm({
            title: `Are you sure to process ${payload.length} records! ?`,
            content: <div>Are you sure ?</div>,
            onOk: () => {
                message.info(`${payload.length} records will be process!`)
                props.processReconciliationData(payload, voucher, 'PV');
            },
        });
    }


    return (
        <div>

            {pvSummary && (
                <>
                    <Row gutter={[16, 16]}>
                        <Col key={'total'}>
                            <Tag color='magenta'>{`Total: ${pvSummary.total}`}</Tag>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginBottom: '10px' }}>
                        {Object.entries(pvSummary.byAction)
                            // Show real actions first, keep NO_ACTION last.
                            .sort(([a], [b]) => (a === 'NO_ACTION' ? 1 : b === 'NO_ACTION' ? -1 : a.localeCompare(b)))
                            .map(([action, c]) => (
                                <Col key={action}>
                                    <Tag
                                        className='gx-rounded-md'
                                        color={action === 'NO_ACTION' ? '#8c8c8c' : '#06BB8A'}
                                    >
                                        {action === 'NO_ACTION'
                                            ? `No Action: ${c.total}`
                                            : `${action}: ${c.total} (saved ${c.saved})`}
                                    </Tag>
                                </Col>
                            ))
                        }
                    </Row>
                </>
            )}

            {data && <Table size='small' dataSource={data} columns={columns} rowKey={(record) => `${record.time}-${record._id}`} onChange={changeTable} rowClassName={rowClassName} />}

            <div style={{ marginTop: '10px' }}>
                <Row gutter={8}>
                    <Col xs={24} sm={12} md={8} lg={4} xl={4}>
                        <Select
                            allowClear
                            value={bulkActionValue || undefined}
                            placeholder="Bulk action"
                            style={{ width: '100%' }}
                            onChange={value => setBulkActionValue(value)}
                        >
                            {['NEW_ASSET', 'IGNORE'].map(op => <Select.Option key={op} value={op}><Tooltip title={op}>{op}</Tooltip></Select.Option>)}
                        </Select>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                        <Button disabled={!bulkActionValue || !data || !data.length} type='dashed' onClick={handleBulkActionChange} icon='left'> Add This Action to all above</Button>
                    </Col>
                </Row>
            </div>

            <div style={{ float: 'right', marginTop: '10px' }}>
                <Button type="primary"
                    htmlType="button" loading={props.loading} onClick={submitReconcileData}>
                    Save
                </Button>
                <Button style={{ marginLeft: '5px' }} type="danger" htmlType="button" loading={props.loading}
                    onClick={processReconcileData}>
                    Process Report
                </Button>
            </div>
            {showModel && <PvRecord onCancel={hideModel} visible={showModel} hideModel={hideModel} handleRecordAction={handleRecordAction}
                assets={selectableAssets} data={showModelData} locations={locations} clients={clients} authUser={props.authUser} />}

            <PhotoGalleryModal
                visible={showGallery}
                onCancel={hideGallery}
                photos={galleryData && galleryData.photos}
                title={galleryData && (galleryData.tempAssetCode || galleryData.pvNo)}
            />

        </div>
    )

}

export default PvReconciliation;
